import {del, get, post, put} from "../helpers/api_helper";
import {
    IErrorClassifierErrorKey, IErrorClassifierErrorKeyForm,
    IErrorClassifierGroup,
    IErrorClassifierGroupForm, IErrorClassifierKeyword,
    IErrorClassifierKeywordForm
} from "../store/errorClassifier/types";

export const ErrorClassifierService = {
    // GROUPS
    getGroupsAll: async (): Promise<IErrorClassifierGroup[]> => {
        return get(`/error-map/groups/all`)
    },

    getGroupById: async (id: number): Promise<IErrorClassifierGroup> => {
        return get(`/error-map/groups/${id}`)
    },

    createGroup: async (data: IErrorClassifierGroupForm) => {
        return post(`/error-map/groups/create`, data)
    },

    updateGroup: async (id: number, data: IErrorClassifierGroupForm) => {
        return put(`/error-map/groups/${id}`, data)
    },

    removeGroup: async (id: number) => {
        return del(`/error-map/groups/${id}`)
    },

    // KEYWORDS
    getKeywordById: async (id: number): Promise<IErrorClassifierKeyword> => {
        return get(`/error-map/keywords/${id}`)
    },

    createKeyword: async (data: IErrorClassifierKeywordForm) => {
        return post(`/error-map/keywords/create`, data)
    },

    updateKeyword: async (id: number, data: IErrorClassifierKeywordForm) => {
        return put(`/error-map/keywords/${id}`, data)
    },

    removeKeyword: async (id: number) => {
        return del(`/error-map/keywords/${id}`)
    },

    // ERROR KEYS
    getErrorKeys: async (): Promise<IErrorClassifierErrorKey[]> => {
        return get(`/error-map/error-flags`)
    },
    createErrorKey: async (data: IErrorClassifierErrorKeyForm): Promise<IErrorClassifierErrorKey> => {
        return post(`/error-map/error-flags/create`, data)
    },
    updateErrorKey: async (id: number, data: IErrorClassifierErrorKeyForm): Promise<IErrorClassifierErrorKey> => {
        return put(`/error-map/error-flags/${id}`, data)
    },
    removeErrorKey: async (id: number) => {
        return del(`/error-map/error-flags/${id}`)
    }
}